import { useFormSubmissionAutoSaveState } from '@oneblink/apps-react'
import { submissionService } from '@oneblink/apps-react'
import { FormTypes } from '@oneblink/types'
import useAutoSaveKey from './useAutoSaveKey'

type Props = {
  form: FormTypes.Form
  initialSubmission?: Record<string, unknown>
  onSubmit: (newFormSubmission: submissionService.NewFormSubmission) => void
  onCancel: () => void
  onSaveDraft: (newDratSubmission: submissionService.NewDraftSubmission) => void
}

export default function useAutoSaveControlledForm({
  form,
  initialSubmission,
  onSubmit,
  onCancel,
  onSaveDraft,
}: Props) {
  const autoSaveKey = useAutoSaveKey(initialSubmission)

  const {
    definition,
    submission: liveSubmission,
    isLoadingAutoSaveSubmission,
    isAutoSaveSubmissionAvailable,
    startNewSubmission,
    continueAutoSaveSubmission,
    handleSubmit,
    handleCancel,
    handleSaveDraft,
    setFormSubmission,
    executedLookups,
  } = useFormSubmissionAutoSaveState({
    form,
    initialSubmission,
    autoSaveKey,
    onSubmit,
    onCancel,
    onSaveDraft,
    removeAutoSaveDataBeforeSaveDraft: false,
    removeAutoSaveDataBeforeSubmit: false,
  })

  return {
    definition,
    liveSubmission,
    isLoadingAutoSaveSubmission,
    isAutoSaveSubmissionAvailable,
    executedLookups,
    startNewSubmission,
    continueAutoSaveSubmission,
    handleSubmit,
    handleCancel,
    handleSaveDraft,
    setFormSubmission,
  }
}
